import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Dashboard } from './pages/Dashboard';
import { ProfileEditor } from './components/ProfileEditor';
import { LoginPage } from './pages/LoginPage';
import { AdminDashboard } from './pages/AdminDashboard';
import { MeetingHistoryView } from './pages/MeetingHistoryView';
import { fetchMe } from './services/auth';
import { User } from './types';

function App() {
  const [user, setUser] = useState<User | undefined>(undefined);
  const [loading, setLoading] = useState(true);
  const [showProfileEditor, setShowProfileEditor] = useState(false);

  // Hardcoded for MVP
  const sessionId = 1;
  const teamId = 1;

  useEffect(() => {
    const initAuth = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const userData = await fetchMe();
          setUser(userData);
        } catch (err) {
          console.error("Failed to fetch user", err);
          localStorage.removeItem('token');
        }
      }
      setLoading(false);
    };
    initAuth();
  }, []);

  const handleLoginSuccess = async () => {
    const userData = await fetchMe();
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setUser(undefined);
  };

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={
            user ? <Navigate to="/" /> : <LoginPage onLoginSuccess={handleLoginSuccess} />
          }
        />
        <Route
          path="/"
          element={
            !user ? (
              <Navigate to="/login" />
            ) : (
              <Layout
                user={user}
                onLogout={handleLogout}
                onEditProfile={() => setShowProfileEditor(true)}
              >
                <Dashboard currentUser={user} />
                {showProfileEditor && (
                  <ProfileEditor
                    user={user}
                    onUpdate={(updatedUser) => setUser(updatedUser)}
                    onClose={() => setShowProfileEditor(false)}
                  />
                )}
              </Layout>
            )
          }
        />
        <Route
          path="/admin"
          element={
            !user ? (
              <Navigate to="/login" />
            ) : (user.role !== 'admin' && user.role !== 'team_head') ? (
              <Navigate to="/" />
            ) : (
              <Layout
                user={user}
                onLogout={handleLogout}
                onEditProfile={() => setShowProfileEditor(true)}
              >
                <AdminDashboard currentUser={user} />
                {showProfileEditor && (
                  <ProfileEditor
                    user={user}
                    onUpdate={(updatedUser) => setUser(updatedUser)}
                    onClose={() => setShowProfileEditor(false)}
                  />
                )}
              </Layout>
            )
          }
        />
        <Route
          path="/history/:meetingId"
          element={
            !user ? (
              <Navigate to="/login" />
            ) : (
              <MeetingHistoryView />
            )
          }
        />
      </Routes>
    </Router >
  );
}

export default App;
